import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ReportingTemplateId = Brand<number, 'ReportingTemplateId'>;
export const ReportingTemplateId = createBranded<ReportingTemplateId>();
